import script from "./AppSideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSideBar.vue?vue&type=script&lang=ts&setup=true"

import "./AppSideBar.vue?vue&type=style&index=0&id=585e775e&lang=scss&scoped=true"
import "./AppSideBar.vue?vue&type=style&index=1&id=585e775e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585e775e"]])

export default __exports__